
function Footer() {    
    //const currentYearEn = new Date().getFullYear();
    //const currentYearTh = currentYearEn + 543;
    return (
        <>
            
        </>
    );
}

export default Footer;